import { render, staticRenderFns } from "./cart-card.vue?vue&type=template&id=59ed814e&"
import script from "./cart-card.vue?vue&type=script&lang=js&"
export * from "./cart-card.vue?vue&type=script&lang=js&"
import style0 from "./cart-card.vue?vue&type=style&index=0&id=59ed814e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports